import { render, staticRenderFns } from "./void_button.vue?vue&type=template&id=b030193e&"
import script from "./void_button.vue?vue&type=script&lang=js&"
export * from "./void_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports